module.exports = __webpack_public_path__ + "img/bg-login2.a50fc7e8.jpg";